<template>
  <div class="child-list-item-birthday">
      <div class="row child">
        <div class="col-3 col-sm-4 col-md-3">
          <child-thumbnail :key="child.child_id" :childReset="getChild(child.child_id).reset" :child="getChild(child.child_id)"></child-thumbnail>
        </div>
        <div class="col-9 col-sm-8 col-md-9">
          <span class="d-none d-sm-block" style="margin-top: 5px"></span>
          <router-link :to="'/children/' + child.child_id">
            <h3>{{ getChild(child.child_id).full_name }}</h3>
            <p>Jarig op {{ getDayOfWeekCurrentYear(child.date_of_birth) }} {{ this.$moment(child.date_of_birth).format('D MMM') }} (wordt {{ child.age }} jaar)</p>
          </router-link>
        </div>
    </div>
  </div>
</template>

<script>
import ChildThumbnail from '@/components/Child-Thumbnail'
export default {
  name: 'child-list-item-birthday',
  props: ['child'],
  components: {
    ChildThumbnail
  },
  methods: {
    getDayOfWeekCurrentYear (dateOfBirth) {
      return this.$moment(`${this.$moment().format('YYYY')}-${this.$moment(dateOfBirth).format('MM-DD')}`).format('ddd')
    }
  }
}
</script>

<style scoped>
  h3, p {
    margin: 0;
  }
  a {
    color: #666;
  }
  .child {
    padding-top: 5px;
    padding-bottom: 5px;
  }
</style>
